// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2nD6X","icon":"SortAdornment_icon__1hTd5","up":"SortAdornment_up__2DIp6","down":"SortAdornment_down__3X1QO","active":"SortAdornment_active__11TcA"};